import { generatePlayerKey } from '../../../shared/chart-options';

export const POSSESSIONS_GROUP_LENGTH = 20;

export function getCombinationsReport(response, possessions) {
  const hasData = !!response;
  const combinations = hasData ? response.combos : [];
  const players = getPlayers(combinations);
  const data = getCombinationsData(combinations, possessions);
  const possessionGroups = getPossessionGroups(data);
  const bounds = getBounds(hasData ? response : {});

  return {
    hasData,
    players,
    data,
    possessionGroups,
    bounds,
    config: COMBINATION_CONFIG,
  };
}

function getPlayers(combinations) {
  const players = combinations.reduce((players, combination) => {
    const combinationPlayers = getCombinationPlayers(combination);

    players.push(generatePlayerKey(combinationPlayers.player1));
    players.push(generatePlayerKey(combinationPlayers.player2));

    return players;
  }, []);

  return [...new Set(players)].sort((a, b) => a - b);
}

function getBounds(response) {
  return {
    min: response.bounds.min_possessions,
    max: response.bounds.max_possessions,
  };
}

function getCombinationsData(combinations, possessions) {
  let data = combinations.map(combination => ({
    ...getCombinationPlayers(combination),
    synergy: combination.stats.synergy.ratings.net,
    possessions: combination.stats.values.ratings.possessions,
    offense: combination.stats.values.ratings.offense,
    defense: combination.stats.values.ratings.defense,
    net: combination.stats.values.ratings.net,
  }));
  if (possessions && possessions.length > 0) {
    data = data.filter(
      combination =>
        combination.possessions >= possessions[0] &&
        combination.possessions <= possessions[1],
    );
  }
  return data;
}

function getCombinationPlayers(combination) {
  return {
    player1: { ...combination.players[0] },
    player2: { ...combination.players[1] },
  };
}

function getPossessionGroups(combinations) {
  const groupedPossessions = initPossessionsGroups(combinations);

  combinations.forEach(combination => {
    const possessions = combination.possessions;
    const index = Math.floor(possessions / POSSESSIONS_GROUP_LENGTH);

    groupedPossessions[index].value = groupedPossessions[index].value + 1;

    return groupedPossessions;
  }, {});

  return groupedPossessions;
}

function initPossessionsGroups(combinations) {
  const maxIndex = findMaxPossessionGroupIndex(combinations);
  const group = {};

  for (let index = 0; index <= maxIndex; index++) {
    const min = index * POSSESSIONS_GROUP_LENGTH;
    const max = min + (POSSESSIONS_GROUP_LENGTH - 1);
    group[index] = { min, max, value: 0 };
  }

  return group;
}

function findMaxPossessionGroupIndex(combinations) {
  if (!combinations || !combinations.length) return 0;

  const possessions = combinations.map(combination => combination.possessions);
  const maxPossessions = Math.max(...possessions);

  return Math.floor(maxPossessions / POSSESSIONS_GROUP_LENGTH);
}

export const COMBINATION_CONFIG = {
  offense: {
    name: 'Offensive Rating',
    property: 'offense',
    colors: ['#B3E0A6', '#74BB68', '#5EA654', '#45934F', '#24693D'],
  },
  defense: {
    name: 'Defensive Rating',
    property: 'defense',
    colors: ['#FFBEB2', '#FEA898', '#F77A65', '#F26250', '#AE123A'],
  },
  synergy: {
    name: 'Synergy',
    property: 'synergy',
    colors: ['#9E3D22', '#EA6F22', '#D9D5C9', '#91C4E0', '#5484B0'],
  },
  net: {
    name: 'Net Rating',
    property: 'net',
    colors: ['#FFBEB2', '#FEA898', '#D9D5C9', '#91C4E0', '#5484B0'],
  },
};
